import * as React from 'react';
import {connect} from 'react-redux';

import {Checkbox} from 'shells/checkbox/checkbox';

import type {UpdateDefaultStagesetForOnboardingWizardInputFieldInput} from 'nutshell-graphql-types';

import type {NutshellState} from '../../../store';

import {addOnboardingOption, removeOnboardingOption} from '../ui-actions';
import {isOptionChosen} from '../ui-selectors';

import styles from './onboarding-option.module.css';

type OwnProps = {
    option: keyof UpdateDefaultStagesetForOnboardingWizardInputFieldInput;
    label: string;
};
type StateProps = {
    isChecked: boolean;
};
type DispatchProps = {
    onChange: (isChecked: boolean) => void;
};
type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState, ownProps: OwnProps): StateProps {
    return {
        isChecked: isOptionChosen(state, ownProps.option),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch, ownProps: OwnProps): DispatchProps {
    return {
        onChange: (isChecked) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            isChecked
                ? dispatch(addOnboardingOption(ownProps.option))
                : dispatch(removeOnboardingOption(ownProps.option));
        },
    };
}

export class OnboardingOptionComponent extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['onboarding-option']}>
                <Checkbox
                    isLarge={true}
                    label={this.props.label}
                    checked={this.props.isChecked}
                    onChange={this.props.onChange}
                />
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const OnboardingOption = connector(OnboardingOptionComponent);
